import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Clock, MapPin, Calendar, X } from 'lucide-react';
import ImagesDev from '../api/images';
import Link from './Link';

export function EventsHighlights({ parent, noHeader }) {
  const [MediaData, setMediaData] = useState([]);
  const highlights = [
    {
      id: 1,
      image: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7",
      title: "Worship Session"
    },
    {
      id: 2,
      image: ImagesDev.heroImages[7],
      title: "Prayer Time"
    },
    {
      id: 3,
      image: "https://images.unsplash.com/photo-1501281668745-f7f57925c3b4",
      title: "Ministry Time"
    },
    {
      id: 4,
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e",
      title: "Testimonies"
    }
  ];

  const getCategories = async () => {
    let categories = [];
    const CATEGORIES_KEY = "attachment_categories";

    // const cachedCategories = localStorage.getItem(CATEGORIES_KEY);
    const cachedCategories = false;
    if (cachedCategories) {
      console.log("used local categories");
      categories = JSON.parse(cachedCategories);
    } else {
      console.log("fetching categories from API");
      const categoriesREST = await fetch('https://tsoministries.com/wp-json/wp/v2/attachment_category')
        .then(res => res.json());
      localStorage.setItem(CATEGORIES_KEY, JSON.stringify(categoriesREST));
      categories = categoriesREST;
    }

    return categories;
  }

  const fetchMediaByCategorySlug = async (slug) => {
    try {
      let allMedia = [];
      let page = 1;
      let totalPages = 1;
      // const categories = await fetch('https://tsoministries.com/wp-json/wp/v2/attachment_category')
      //   .then(res => res.json());
      // const slug = "life_in_the_spirit";
      const categories = await getCategories();
      const category = categories?.find(cat => cat.slug === slug);

      if (!category) {
        throw new Error("Category not found");
      }
      const categoryId = category.id;

      while (page <= totalPages) {
        const response = await fetch(
          `https://tsoministries.com/wp-json/wp/v2/media?attachment_category=${categoryId}&per_page=100&page=${page}&_embed`
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (!Array.isArray(data)) {
          console.error("Expected array but got:", data);
          break; // Stop the loop, something’s wrong
        }

        if (page === 1) {
          const headerTotalPages = response.headers.get("X-WP-TotalPages");
          if (headerTotalPages) {
            totalPages = parseInt(headerTotalPages, 10);
          }
        }

        allMedia = [...allMedia, ...data];
        page++;
      }

      setMediaData(allMedia);
      // localStorage.setItem(GALLERY_KEY, JSON.stringify(allMedia));
    } catch (error) {
      console.error("Error fetching media by category slug:", error);
    }
  };

  useEffect(() => {
    fetchMediaByCategorySlug(parent)
  }, [])

  return (
    <section className="relative mb-16">
      {!noHeader && <div className="flex items-center justify-between mb-8">
        <h2 className="text-3xl font-bold">Media Highlights</h2>
        <Link
          to="/gallery"
          className="flex items-center space-x-2 text-orange-400 hover:text-orange-300 transition-colors"
        >
          <span>View Full Gallery</span>
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>}

      {/* <p>{JSON.stringify(MediaData)}</p> */}

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {MediaData.sort(() => 0.5 - Math.random()).slice(0,4).map((highlight, index) => {
          const optimizedImageUrl =
          highlight.media_details?.sizes?.["medium_large"]?.source_url ||
          highlight.media_details?.sizes?.["medium"]?.source_url ||
          highlight.media_details?.sizes?.["thumbnail"]?.source_url ||
          highlight.source_url;
          return (
            <motion.div
              key={highlight.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="group relative aspect-square overflow-hidden rounded-xl"
            >
              <img
                src={optimizedImageUrl}
                alt={highlight.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  {/* <p className="text-white font-medium">{highlight.title}</p> */}
                </div>
              </div>
            </motion.div>
          )
        })}
      </div>
    </section>
  );
}

export function EventsHighlight_({ parent }) {
  const [selectedEvent, setSelectedEvent] = useState(null);
  
  // This would typically come from your API/database
  const events = [
    {
      id: 1,
      title: "Power Night",
      date: "March 30, 2024",
      time: "6:00 PM",
      location: "Main Auditorium",
      description: "A night of supernatural encounters and divine manifestations",
      image: "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7",
      highlights: [
        "https://images.unsplash.com/photo-1519834089823-af2d966a0648",
        "https://images.unsplash.com/photo-1501281668745-f7f57925c3b4",
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e"
      ]
    },
    {
      id: 2,
      title: "Healing Service",
      date: "April 15, 2024",
      time: "5:00 PM",
      location: "Prayer Chapel",
      description: "Experience the healing power of God",
      image: "https://images.unsplash.com/photo-1519677584237-752f8853252e",
      highlights: [
        "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7",
        "https://images.unsplash.com/photo-1519834089823-af2d966a0648",
        "https://images.unsplash.com/photo-1501281668745-f7f57925c3b4"
      ]
    }
  ];

  return (
    <div className="mb-16">
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-3xl font-bold">Event Highlights</h2>
        <Link
          to="/gallery"
          className="flex items-center space-x-2 text-purple-400 hover:text-purple-300 transition-colors"
        >
          <span>View Full Gallery</span>
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {events.map((event, index) => (
          <motion.div
            key={event.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="group relative overflow-hidden rounded-xl bg-white/5 backdrop-blur-sm border border-white/10"
          >
            <div className="aspect-[16/9] relative overflow-hidden">
              <img
                src={event.image}
                alt={event.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-2xl font-bold mb-2">{event.title}</h3>
                  <p className="text-gray-300 mb-4">{event.description}</p>
                  <div className="flex flex-wrap gap-4 text-sm text-gray-300">
                    <div className="flex items-center gap-2">
                      <Calendar className="w-4 h-4" />
                      <span>{event.date}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Clock className="w-4 h-4" />
                      <span>{event.time}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <MapPin className="w-4 h-4" />
                      <span>{event.location}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-4">
              <div className="grid grid-cols-3 gap-2">
                {event.highlights.map((highlight, i) => (
                  <motion.div
                    key={i}
                    className="aspect-square relative overflow-hidden rounded-lg cursor-pointer"
                    whileHover={{ scale: 1.05 }}
                    onClick={() => setSelectedEvent(event)}
                  >
                    <img
                      src={highlight}
                      alt={`Highlight ${i + 1}`}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/20 hover:bg-black/40 transition-colors" />
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Full Gallery Modal */}
      <AnimatePresence>
        {selectedEvent && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90"
          >
            <motion.button
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.5 }}
              onClick={() => setSelectedEvent(null)}
              className="absolute top-4 right-4 p-2 text-white/60 hover:text-white transition-colors"
            >
              <X className="w-6 h-6" />
            </motion.button>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              className="w-full max-w-6xl"
            >
              <h3 className="text-2xl font-bold mb-6">{selectedEvent.title} Highlights</h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {selectedEvent.highlights.map((image, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.1 }}
                    className="aspect-square relative overflow-hidden rounded-lg"
                  >
                    <img
                      src={image}
                      alt={`Gallery ${index + 1}`}
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}